import { RecipeDetail } from "@corpuscomplete/core-ui/nutrition/recipe/detail";
import { RecipeEditPage } from "@corpuscomplete/web/modules/nutrition/recipe/pages/recipe-edit";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/recipes/$id/edit")({
  component: () => {
    const { id } = Route.useParams();
    return <RecipeEditPage id={id} />;
  },
  loader: async ({ params, context }) => {
    if (context.zero) {
      RecipeDetail.preload(context.zero, params.id);
    }
  },
});
